import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IListOfUsers } from '../../interface/administrator/admin';
import { IDoaCategory } from '../../interface/administrator/admin';
import { IDoaSubCategory } from '../../interface/administrator/admin';
import { IDoaTypes } from '../../interface/administrator/admin';
import { INonCNLEmployees } from '../../interface/administrator/admin';
import { IDoaLog } from '../../interface/administrator/admin';
import { IDoaMaster } from '../../interface/administrator/admin';
const apiUrl = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }

  //UserSetup
  public getUsersList(): Observable<IListOfUsers[]> {
    return this.http.get<IListOfUsers[]>(`${apiUrl}/Administrator/GetUsersList`);
  }
  public addUser(obj: IListOfUsers[]): Observable<any> {
    return this.http.post(`${apiUrl}/Administrator/AddUser`, obj);
  }
  public updateUser(obj: IListOfUsers[]): Observable<any> {
    return this.http.put(`${apiUrl}/Administrator/UpdateUser`, obj);
  }
  public deleteUser(id: number): Observable<any> {
    return this.http.delete(`${apiUrl}/Administrator/DeleteUser?id=${id}`);
  }
  public getUsersWorksheet(obj: any[]): Observable<Blob> {
    return this.http.post(`${apiUrl}/Administrator/UsersWorksheet`, obj, { responseType: 'blob' });
  }

  //DoaCategory
  public getDoaCategory(): Observable<IDoaCategory[]> {
    return this.http.get<IDoaCategory[]>(`${apiUrl}/Administrator/GetDoaCategories`);
  }
  public addDoaCategory(obj: IDoaCategory[]): Observable<any> {
    return this.http.post(`${apiUrl}/Administrator/AddDoaCategory`, obj);
  }
  public updateDoaCategory(obj: IDoaCategory[]): Observable<any> {
    return this.http.put(`${apiUrl}/Administrator/UpdateDoaCategory`, obj);
  }
  public deleteDoaCategory(id: number): Observable<any> {
    return this.http.delete(`${apiUrl}/Administrator/DeleteDoaCategory?id=${id}`);
  }
  public getDoaCategoryWorksheet(obj: any[]): Observable<Blob> {
    return this.http.post(`${apiUrl}/Administrator/DoaCategoryWorksheet`, obj, { responseType: 'blob' });
  }

  //DoaSubCategory
  public getDoaSubCategory(): Observable<IDoaSubCategory[]> {
    return this.http.get<IDoaSubCategory[]>(`${apiUrl}/Administrator/GetDoaSubCategories`);
  }
  public addDoaSubCategory(obj: IDoaSubCategory[]): Observable<any> {
    return this.http.post(`${apiUrl}/Administrator/AddDoaSubCategory`, obj);
  }
  public updateDoaSubCategory(obj: IDoaSubCategory[]): Observable<any> {
    return this.http.put(`${apiUrl}/Administrator/UpdateDoaSubCategory`, obj);
  }
  public deleteDoaSubCategory(id: number): Observable<any> {
    return this.http.delete(`${apiUrl}/Administrator/DeleteDoaSubCategory?id=${id}`);
  }
  public getSubCategoriesWorksheet(obj: any[]): Observable<Blob> {
    return this.http.post(`${apiUrl}/Administrator/SubCategoriesWorksheet`, obj, { responseType: 'blob' });
  }

  //DoaTypes
  public getDoaTypes(): Observable<IDoaTypes[]> {
    return this.http.get<IDoaTypes[]>(`${apiUrl}/Administrator/GetDoaTypes`);
  }
  public addDoaType(obj: IDoaTypes[]): Observable<any> {
    return this.http.post(`${apiUrl}/Administrator/AddDoaType`, obj);
  }
  public updateDoaType(obj: IDoaTypes[]): Observable<any> {
    return this.http.put(`${apiUrl}/Administrator/UpdateDoaType`, obj);
  }
  public deleteDoaType(id: number): Observable<any> {
    return this.http.delete(`${apiUrl}/Administrator/DeleteDoaType?id=${id}`);
  }
  public getDoaTypesWorksheet(obj: any[]): Observable<Blob> {
    return this.http.post(`${apiUrl}/Administrator/DoaTypesWorksheet`, obj, { responseType: 'blob' });
  }

  //NonCNLEmp
  public getNonCNLEmployees(): Observable<INonCNLEmployees[]> {
    return this.http.get<INonCNLEmployees[]>(`${apiUrl}/Administrator/getNonCNLEmp`);
  }
  public addNonCNLEmployee(obj: INonCNLEmployees[]): Observable<any> {
    return this.http.post(`${apiUrl}/Administrator/AddNonCNLEmp`, obj);
  }
  public updateNonCNLEmployee(obj: INonCNLEmployees[]): Observable<any> {
    return this.http.put(`${apiUrl}/Administrator/UpdateNonCNLEmp`, obj);
  }
  public deleteNonCNLEmployee(id: number): Observable<any> {
    return this.http.delete(`${apiUrl}/Administrator/DeleteNonCNLEmp?id=${id}`);
  }
  public getNonCNLEmpWorksheet(obj: any[]): Observable<Blob> {
    return this.http.post(`${apiUrl}/Administrator/NonCNLEmpWorksheet`, obj, { responseType: 'blob' });
  }

  //DoaLogReport
  public getEmployeeLogs(empNo: string): Observable<IDoaLog[]> {
    return this.http.get<IDoaLog[]>(`${apiUrl}/Administrator/DoaLogs/emp?empNo=${empNo}`);
  }
  public getUserLogs(userCai: string): Observable<IDoaLog[]> {
    return this.http.get<IDoaLog[]>(`${apiUrl}/Administrator/DoaLogs/user?userId=${userCai}`);
  }
  public getEmployeeDetails(empNo: string): Observable<any> {
    return this.http.get<any>(`${apiUrl}/Administrator/EmployeeInfo?empNo=${empNo}`);
  }
  public getUserDetails(userCai: string): Observable<any> {
    return this.http.get<any>(`${apiUrl}/Administrator/UserInfo?userId=${userCai}`);
  }
  getEmpLogsWorksheet(identifier: string, type: string): Observable<Blob> {
    return this.http.get(`${apiUrl}/Administrator/DOALogsWorksheet?identifier=${identifier}&type=${type}`, { responseType: 'blob' });
  }

  //UsdRate
  public loadUsdRate(): Observable<{ usdRate1: number }> {
    return this.http.get<{ usdRate1: number }>(`${apiUrl}/Administrator/UsdRate`);
  }
  public saveUsdRate(usdRate: number): Observable<void> {
    return this.http.put<void>(`${apiUrl}/Administrator/UsdRate`, { usdRate1: usdRate });
  }

  //EmployeeDoaSetup
  public getDoaDetails(empNo: string): Observable<any[]> {
    return this.http.get<any[]>(`${apiUrl}/Administrator/doaMaster/${empNo}`);
  }
  public submitEmployeeDoaReq(doaDetails: IDoaMaster[]): Observable<any> {
    return this.http.post(`${apiUrl}/Administrator/EmployeeDoaReq`, doaDetails);
  }
  public searchEmployee(query: string): Observable<any[]> {
    return this.http.get<any[]>(`${apiUrl}/Administrator/searchEmployee?query=${query}`);
  }
  public getEffectiveDate(empNo: string): Observable<any> {
    return this.http.get<any>(`${apiUrl}/Administrator/effectiveDate/${empNo}`);
  }

}
